import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var aadhaarConfirmationConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: true,
  stepDetailsProps: {
    title: 'STEP 3',
    heading: 'Details confirmation',
    avatarIcon: 'KycVerificationIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  prefillYearOnly: true,
  inputsDataProps: {
    fullName: {
      label: 'Full name',
      isDisabled: true
    },
    guardianName: {
      label: 'Father/Spouse/Guardian name'
    },
    dateInput: {
      mode: 'date',
      variant: 'input',
      label: 'Date of birth',
      inputProps: {
        showAppend: true,
        appendItems: {
          postfixIcon: {
            iconName: 'DownChevronIcon'
          }
        }
      },
      hideDropdownAndNavigationCta: true,
      withPortal: true,
      inputVersion: 'variable-width'
    }
  }
};
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};